import { useStore, useStoreMap } from "effector-react";
import { $trackSourceLoadingMap } from "./model";
import { $playerCurrentTrackSource } from "../../domain/player-track-queue";
export var useIsThisPlaylistLoading = function (id) {
    return useStoreMap({
        store: $trackSourceLoadingMap,
        keys: [id],
        fn: function (map, _a) {
            var playlistId = _a[0];
            return !!map.playlist[playlistId];
        },
    });
};
export var useIsThisTimetableLoading = function (id) {
    return useStoreMap({
        store: $trackSourceLoadingMap,
        keys: [id],
        fn: function (map, _a) {
            var timetableId = _a[0];
            return !!map.timetable[timetableId];
        },
    });
};
export var useIsCurrentTrackSourceLoading = function () {
    var currentTrackSource = useStore($playerCurrentTrackSource);
    return useStoreMap({
        store: $trackSourceLoadingMap,
        keys: [currentTrackSource],
        fn: function (map, _a) {
            var trackSource = _a[0];
            if (!trackSource)
                return false;
            if (trackSource.type === "playlist") {
                return !!map.playlist[trackSource.attributes.id];
            }
            if (trackSource.type === "today_timetable") {
                return !!map.timetable[trackSource.attributes.id];
            }
            return false;
        },
    });
};
